var _circle, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendButtonHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3974,
    cy: 30.1923,
    r: 29.3974,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.6681,
    height: 27.6681,
    transform: "translate(18.1562 16.3574)",
    fill: "url(#paint0_linear_2126_5344)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.193 18.2932C20.3221 18.1836 20.4806 18.1144 20.6488 18.0941C20.817 18.0738 20.9874 18.1034 21.1389 18.1791L43.6192 29.4193C43.7627 29.4912 43.8833 29.6015 43.9675 29.738C44.0518 29.8745 44.0965 30.0318 44.0965 30.1922C44.0965 30.3527 44.0518 30.5099 43.9675 30.6465C43.8833 30.783 43.7627 30.8933 43.6192 30.9652L21.1389 42.2054C20.9875 42.2813 20.8171 42.3111 20.6489 42.291C20.4807 42.271 20.3221 42.2019 20.1928 42.0925C20.0635 41.9831 19.9692 41.8381 19.9216 41.6756C19.874 41.5131 19.8751 41.3401 19.925 41.1782L23.3056 30.1922L19.925 19.2063C19.8754 19.0445 19.8744 18.8718 19.9221 18.7096C19.9697 18.5473 20.0639 18.4025 20.193 18.2932ZM24.8481 31.0569L22.173 39.755L41.2986 30.1922L22.173 20.6295L24.8481 29.3276H34.5856C34.8149 29.3276 35.0348 29.4187 35.197 29.5809C35.3591 29.743 35.4502 29.9629 35.4502 30.1922C35.4502 30.4216 35.3591 30.6415 35.197 30.8036C35.0348 30.9658 34.8149 31.0569 34.5856 31.0569H24.8481Z",
    fill: "url(#paint1_linear_2126_5344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2126_5344",
    x1: 13.8341,
    y1: 0,
    x2: 13.8341,
    y2: 27.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2126_5344",
    x1: 31.9916,
    y1: 18.0879,
    x2: 31.9916,
    y2: 42.2971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#118CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#044480"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButtonHover);
export default __webpack_public_path__ + "static/media/send-button-hover.96569d411e56f56afb82e7df48dee53a.svg";
export { ForwardRef as ReactComponent };